import {pumaInit} from "../helper/PUMAMetricHelper";

const APP_NAME = "dolphin";
const HOST = "web";
const BASE_PATH = `${APP_NAME}://${HOST}`;

export function callNative(actionType, command, options = {}) {
    const nativeCommand = `${BASE_PATH}?action_type=${actionType}&command=${command}`;
    const urlIntent = nativeCommand + getOptions(options);
    window.location.href = urlIntent;
    pumaInit();
}

function getOptions(options) {
    let optionString = '';
    for (const key in options) {
        optionString += `&${key}=${options[key]}`;
    }
    return optionString;
}

export const NativeActions = {
    PRINT: "print",
    NAVIGATION: "navigation"
};

export const NativeCommands = {
    CHANGE_PRINTER: "changePrinter",
    SET_SAL_FORMAT: "setSALFormat",
    PRINT_SAL: "printSAL",
    BACK: "back"
};

export const closeOnBack = () => {
    callNative(NativeActions.NAVIGATION, NativeCommands.BACK);
}


// WEBPACK FOOTER //
// ./src/components/utils/NativeBridge.js